import { render, staticRenderFns } from "./RegistrationAndLoginSupport.vue?vue&type=template&id=e05137fa&scoped=true&"
import script from "./RegistrationAndLoginSupport.vue?vue&type=script&lang=js&"
export * from "./RegistrationAndLoginSupport.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationAndLoginSupport.vue?vue&type=style&index=0&id=e05137fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05137fa",
  null
  
)

export default component.exports